export default "__VITE_ASSET__6597b240__"